<script setup>
import { useI18n } from 'vue-i18n';

defineProps({
  enabled: {
    type: Boolean,
    default: false,
  },
  isSaving: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['toggle']);

const { t } = useI18n();
</script>

<template>
  <div
    class="flex flex-col gap-4 rounded-lg border border-n-weak bg-n-surface-1 p-5"
  >
    <div class="flex items-center justify-between gap-4">
      <div class="flex min-w-0 flex-col gap-2">
        <span class="text-xs font-medium text-n-slate-11">
          {{ t('ASSISTANT.SETTINGS.STATUS_CARD.LABEL') }}
        </span>
        <span
          class="flex items-center gap-2 text-sm font-semibold text-n-slate-12"
        >
          <span
            class="size-2 shrink-0 rounded-full"
            :class="enabled ? 'bg-n-brand' : 'bg-n-slate-9'"
            aria-hidden="true"
          />
          {{
            enabled
              ? t('ASSISTANT.SETTINGS.STATUS_CARD.ON')
              : t('ASSISTANT.SETTINGS.STATUS_CARD.OFF')
          }}
        </span>
      </div>
      <button
        type="button"
        role="switch"
        :aria-checked="enabled"
        :aria-label="t('ASSISTANT.SETTINGS.ENABLED')"
        :disabled="isSaving"
        class="inline-flex h-11 w-11 shrink-0 items-center rounded-md !p-0 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-n-blue-8 disabled:cursor-wait disabled:opacity-60"
        @click="emit('toggle')"
      >
        <span
          class="relative block h-6 w-11 shrink-0 rounded-full transition-colors"
          :class="enabled ? 'bg-n-brand' : 'bg-n-slate-6'"
        >
          <span
            class="absolute top-0.5 block size-5 rounded-full bg-n-surface-1 shadow-sm transition-transform motion-reduce:transition-none ltr:left-0.5 rtl:right-0.5"
            :class="
              enabled ? 'ltr:translate-x-5 rtl:-translate-x-5' : 'translate-x-0'
            "
          />
        </span>
      </button>
    </div>
    <p class="mb-0 text-xs leading-6 text-n-slate-11">
      {{ t('ASSISTANT.SETTINGS.ENABLED_DESCRIPTION') }}
    </p>
  </div>
</template>
